import React from "react";
import { Table } from "react-bootstrap";
// import useReactRouter from "use-react-router";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import ReactHTMLTableToExcel from "react-html-table-to-excel";
// import {
//   faBoxesStacked,
//   faFileExcel,
//   faPlus,
//   faDollarSign,
//   faPrint,
// } from "@fortawesome/free-solid-svg-icons";
// import { ChromePicker } from "react-color";
// import * as _ from "lodash";

import moment from "moment";
import {
  convertOrderStatus,
  convertOrderType,
} from "../../helpers/orderStatus";
// import { convertPaymentStatus } from "../../helpers/paymentStatus";
// import EmptyComponent from "../../components/EmptyComponent";
import "react-spring-bottom-sheet/dist/style.css";
import PaginationHelper from "../../helpers/PaginationHelper";
// import { COLOR_APP } from "../../constants";

function OrderGroupDownload({ orderGroupDownload }) {
  const getCfMessage = (orders) => {
    return orders?.map(({ cfMessage }) => cfMessage).join(", ");
  };
  const getProductName = (orders) => {
    return orders?.map(({ productName }) => productName).join(", ");
  };
  const getProductAmount = (orders) => {
    return orders?.reduce((total, { amount }) => total + amount, 0);
  };

  // Paggination helper
  const { _limit, _skip, Pagination_helper } = PaginationHelper();
  return (
    <Table
      id="table-to-xls"
      style={{
        marginTop: "20px",
        borderCollapse: "collapse",
        width: "100% ",
        display: "none",
      }}>
      <tbody>
        <tr
          style={{
            padding: "0px 26px",
            paddingBottom: "12px",
            with: "10%",
            borderBottom: "1px solid #DFE2E9",
            textAlign: "left",
            height: "59px",
            verticalAlign: "top",
          }}>
          <th style={{ width: "37px" }}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <p style={{ padding: 0, margin: 0 }}>#</p>
              <div style={{ marginLeft: "10px" }}>
                <div className="up-arrow"></div>
                <div className="down-arrow"></div>
              </div>
            </div>
          </th>
          <th style={{ width: "144px" }}>ເລກທີໃບສັ່ງຊື້</th>
          <th style={{ width: "144px" }}>ຫົວຂໍ້</th>
          <th style={{ width: "143px" }}>ຊື່ລູກຄ້າ</th>
          <th style={{ width: "92px" }}>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <p style={{ padding: 0, margin: 0 }}>ປະເພດ</p>
            </div>
          </th>
          <th>ລະຫັດ CF</th>
          <th>ຊື່ສິນຄ້າ</th>
          <th>
            <div
              style={{
                width: "37px",
                display: "flex",
                alignItems: "center",
              }}>
              <p style={{ padding: 0, margin: 0 }}>ຈຳນວນ</p>
            </div>
          </th>
          <th>
            <div
              style={{
                width: "37px",
                display: "flex",
                alignItems: "center",
              }}>
              <p style={{ padding: 0, margin: 0 }}>ລວມເງິນເກີບທັງໝົດ</p>
            </div>
          </th>
          <th>
            <div
              style={{
                width: "37px",
                display: "flex",
                alignItems: "center",
              }}>
              <p style={{ padding: 0, margin: 0 }}>ລວມເງິນບາດທັງໝົດ</p>
            </div>
          </th>
          <th>
            <div
              style={{
                width: "37px",
                display: "flex",
                alignItems: "center",
              }}>
              <p style={{ padding: 0, margin: 0 }}>ລວມເງິນໂດລາທັງໝົດ</p>
            </div>
          </th>
          <th>ວັນທີ</th>
          <th>ປະເພດຈ່າຍ</th>
          <th style={{ width: "92px" }}>
            <p style={{ padding: 0, margin: 0 }}>ການຊຳລະ</p>
          </th>
          <th>ສະຖານະ</th>
        </tr>
      </tbody>
      <tbody>
        {orderGroupDownload?.map((order, index) => (
          <tr style={{ verticalAlign: "middle", height: "59px" }} key={index}>
            <td>{index + 1 + _limit * (_skip - 1)}</td>
            <td>
              <div
                to={"/order-detailorder"}
                style={{
                  color: "#371895",

                  textDecoration: "underline",
                }}>
                {order?.code ?? "-"}
              </div>
            </td>
            <td>{order?.live?.description}</td>
            <td>
              {order?.customerName !== "" && order?.customerName
                ? order?.customerName
                : order?.cfName}
            </td>
            <td>{convertOrderType(order?.type)}</td>
            <td>{getCfMessage(order?.orders)}</td>
            <td>{getProductName(order?.orders)}</td>
            <td>{getProductAmount(order?.orders)}</td>
            <td>
              {" "}
              <p
                style={{ fontWeight: "bold" }}

              //   onClick={selectedIds.length > 0 ? () => setShowUpdateStatus(true) : () => onUpdateOneOrder(index)}
              >
                {new Intl.NumberFormat("en-US").format(order?.totalPrice)}
              </p>
            </td>
            <td>
              {" "}
              <p
                style={{ fontWeight: "bold" }}

              //   onClick={selectedIds.length > 0 ? () => setShowUpdateStatus(true) : () => onUpdateOneOrder(index)}
              >
                {new Intl.NumberFormat("en-US").format(order?.sumPriceBaht)}
              </p>
            </td>
            <td>
              {" "}
              <p
                style={{ fontWeight: "bold" }}

              //   onClick={selectedIds.length > 0 ? () => setShowUpdateStatus(true) : () => onUpdateOneOrder(index)}
              >
                {new Intl.NumberFormat("en-US").format(order?.sumPriceUsd)}
              </p>
            </td>
            <td>{moment(order?.createdAt).format("DD/MM/YYYY HH:mm")}</td>
            <td>
              {order?.isPaymented === true ? "ຈ່າຍສົດ" : "ໂອນ"}
              {/* {order.payment === "cash" ? "ຈ່າຍສົດ" : ""}
                    {order.payment === "transfer" ? "ໂອນ" : ""} */}
            </td>
            <td style={{ color: order?.isPaymented ? 'green' : 'red' }}>{order?.isPaymented ? 'ຊໍາລະແລ້ວ' : 'ຍັງບໍ່ຊໍາລະ'}</td>
            <td>
                {convertOrderStatus(order?.status)}
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
}
export default OrderGroupDownload;
